import { getRawShipments } from 'lib/firebase';
import { Shipment, ShipmentsDataTableEntry } from 'types';

/** Get all shipments to given supplier. */
export const getShipments = async (supplierId: string): Promise<Shipment[]> => {
    const shipments: Shipment[] = [];
    const data = await getRawShipments(supplierId);
    // Currently have to do some client-side data processing to associate the id number with the shipment obj.
    for (const d in data) {
        const shipment = data[d];
        shipment.$id = d;
        // Add a tracking link.
        generateTrackingLink(shipment);
        shipments.push(shipment);
    }
    return shipments;
};

/** Generate shipment tracking link based on carrier. */
export const generateTrackingLink = (shipment: Shipment): void => {
    const trackingNumber = shipment.tracking_number;

    // No link if we don't have a tracking number.
    if (!trackingNumber) return;

    const carrier = shipment.delivery_carrier.toLowerCase();

    if (carrier.includes('fedex')) {
        shipment.trackingLink = `https://www.fedex.com/apps/fedextrack/?action=track&trackingnumber=${trackingNumber}`;
    } else if (carrier.includes('ups')) {
        shipment.trackingLink = `https://wwwapps.ups.com/tracking/tracking.cgi?tracknum=${trackingNumber}`;
    } else if (carrier.includes('usps')) {
        shipment.trackingLink = `https://tools.usps.com/go/TrackConfirmAction_input?strOrigTrackNum=${trackingNumber}`;
    }
};

/** Return a table mapping short device ids to its shipment time, tracking link, and carrier info.*/
export const getDeviceIdToShipmentDataTable = (
    shipments: Shipment[]
): Record<string, ShipmentsDataTableEntry> => {
    const deviceIdToShipmentDataTable: Record<string, ShipmentsDataTableEntry> =
        {};

    shipments.forEach((shipment: Shipment) => {
        if (shipment.devices) {
            const devicesInShipment = Object.keys(shipment.devices);

            devicesInShipment.forEach((shortId: string) => {
                deviceIdToShipmentDataTable[shortId] = {
                    shipTime: shipment.time,
                    deliveryCarrier: shipment.delivery_carrier ?? '',
                    trackingLink: shipment.trackingLink ?? '',
                };
            });
        }
    });

    return deviceIdToShipmentDataTable;
};
/** Returns a string of the format "(ASDFEWQ) OR (SDWERF) OR (LFDJGJG)"
 * which can be used in an ES query to search for a list of devices by shortId.
 */
export const constructShortDeviceIdQueryString = (
    shipments: Shipment[]
): string => {
    let queryString = '';

    let shortDeviceIds: string[] = [];
    shipments.forEach((shipment: Shipment) => {
        if (shipment.devices) {
            const devicesInShipment = Object.keys(shipment.devices);
            shortDeviceIds = [...shortDeviceIds, ...devicesInShipment];
        }
    });
    shortDeviceIds.forEach((shortId, i) => {
        queryString += `(${shortId})`;
        if (i !== shortDeviceIds.length - 1) queryString += ' OR ';
    });

    return queryString;
};

// export const generateShipmentDevicesQuerystring = (shipment: Shipment): string => {
//     const query = '';

//     // Get list of device ids in the shipment
//     const devicesInShipment = Object.keys(shipment.devices);

//     return query;
// };
